var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1.5C4.17157 1.5 3.5 2.17157 3.5 3V17V17.827L4.23231 17.4428L8.75039 15.0722L12.7458 17.4306L13.5 17.8757V17V12.4257C13.191 12.2471 12.809 12.2471 12.5 12.4257V16.1243L9.01887 14.0694L8.77902 13.9278L8.5324 14.0572L4.5 16.173V3C4.5 2.72386 4.72386 2.5 5 2.5H12C12.2761 2.5 12.5 2.72386 12.5 3V3.36555C12.8062 3.1929 13.1938 3.19291 13.5 3.36555V3C13.5 2.17157 12.8284 1.5 12 1.5H5Z",
    fill: "#13100D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4L14.1226 7.45492H17.7553L14.8164 9.59017L15.9389 13.0451L13 10.9098L10.0611 13.0451L11.1836 9.59017L8.24472 7.45492H11.8774L13 4Z",
    fill: "#13100D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkStar);
export default __webpack_public_path__ + "static/media/bookmark-star.4ab51d46ad3b74dc05d49ee13bb54f08.svg";
export { ForwardRef as ReactComponent };